import _slicedToArray from "/home/gitlab-runner/builds/9s43Yg6F/0/frontend/bb-official/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import i, { useState as s } from "react";
import { Hidden as c, Features as l } from "./hidden.js";

function p(_ref) {
  var n = _ref.onFocus;

  var _s = s(!0),
      _s2 = _slicedToArray(_s, 2),
      r = _s2[0],
      o = _s2[1];

  return r ? i.createElement(c, {
    as: "button",
    type: "button",
    features: l.Focusable,
    onFocus: function onFocus(a) {
      a.preventDefault();
      var e,
          u = 50;

      function t() {
        if (u-- <= 0) {
          e && cancelAnimationFrame(e);
          return;
        }

        if (n()) {
          o(!1), cancelAnimationFrame(e);
          return;
        }

        e = requestAnimationFrame(t);
      }

      e = requestAnimationFrame(t);
    }
  }) : null;
}

export { p as FocusSentinel };